﻿$.fn.dxCtrlDataSaisieModif = function custom_dxCtrlDataSaisieModif(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrldatasaisiemodif dx-ctrl");
        this.createInstance(new cdxCtrlDataSaisieModif(this, option));
    }
    return this;
}

window.cdxCtrlDataSaisieModif = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var dxNom = null
    var dxPrenom = null
    var dxSaisieAdresse = null
    var dxTel = null
    var dxAdrEmail = null
    var dxSociete = null
    function mConstruit() {
        container.css("height", container.innerHeight() + "px")
        container.empty()

        if (option.dataSaisie.id_type_client == null) {
            option.dataSaisie.id_type_client = 1
            try {
                throw new Error("ID_TYPE_CLIENT à null")
            } catch (e) {
                mTraiteMessageJs("erreurjs", e.message, $(location).attr("href"), 0, null, e, "orange")
            }
        }


        var lstObligatoire = (option.onDemandeLstObligatoire ? option.onDemandeLstObligatoire(option.dataSaisie.id_type_client) : [])

        dxSociete = null
        jauge = $("<div/>").appendTo(container).dxCtrlJauge({ height: 20, width: 20 }).dxCtrlJauge("instance")

        var $Table = $("<table style='width:100%;margin:10px 0;'/>").appendTo(container)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:50%'/>").appendTo($Tr)
        dxNom = $("<div/>").appendTo($Td).dxCtrlTextBox({
            label: "Nom" + (lstObligatoire.contains("nom") ? " *" : ""),
            labelMode: "floating",
            value: (option.dataSaisie.con_nom ? option.dataSaisie.con_nom : ""),
            onFocusIn: onFocusInMobile,
            maxLenght: 300,
            onValueChanged: function (e) {
                isDirtyNom = true
                option.dataSaisie.con_nom = e.value
                if (option.onValueChanged) option.onValueChanged(option.dataSaisie)
            },
            onContentReady: function (e) {
                e.component.element().find(".dx-label").html("Nom" + (lstObligatoire.contains("nom") ? " <b style='color:red;font-size:160%;'>*</b>" : ""))
                if (option.isExterne) e.component.element().find("input").removeAttr('autocomplete');
            }
        }).dxCtrlTextBox("instance")
        var $Td = $("<td style='width:50%'/>").appendTo($Tr)
        dxPrenom = $("<div/>").appendTo($Td).dxCtrlTextBox({
            label: "Prénom" + (lstObligatoire.contains("prenom") ? " *" : ""),
            labelMode: "floating",
            value: (option.dataSaisie.con_prenom ? option.dataSaisie.con_prenom : ""),
            onFocusIn: onFocusInMobile,
            maxLenght: 300,
            onValueChanged: function (e) {
                isDirtyPreNom = true
                option.dataSaisie.con_prenom = e.value
                if (option.onValueChanged) option.onValueChanged(option.dataSaisie)
            },
            onContentReady: function (e) {
                e.component.element().find(".dx-label").html("Prénom" + (lstObligatoire.contains("prenom") ? " <b style='color:red;font-size:160%;'>*</b>" : ""))
                if (option.isExterne) e.component.element().find("input").removeAttr('autocomplete');
            }
        }).dxCtrlTextBox("instance")

        if (option.showSociete) {
            var dsTypeClient = ["Particulier", "Société française", "Société européenne (hors France)", "Société étrangère (hors europe)"]
            var dxChoixTypeClient = $("<div style='margin:0px 10px 0 10px;'/>").appendTo(container).dxRadioGroup({
                dataSource: dsTypeClient,
                value: dsTypeClient[option.dataSaisie.id_type_client],
                layout: "horizontal",
                itemTemplate: function (itemData, itemIndex, itemElement) {
                    itemElement.css("line-height", "1")
                    switch (dsTypeClient.indexOf(itemData)) {
                        case 0: case 1: itemElement.html(itemData); break;
                        case 2: itemElement.html("Société européenne<br/>(hors France)"); break;
                        case 3: itemElement.html("Société étrangère<br/>(hors europe)"); break;
                    }
                },
                onValueChanged: function (e) {
                    option.dataSaisie.id_type_client = dsTypeClient.indexOf(e.value)
                    option.dataSaisie.siret = ""
                    option.dataSaisie.tvaintra = ""
                    if (option.dataSaisie.id_type_client == "0") {
                        dxSociete.element().slideUp(200)
                        option.dataSaisie.nom_str = ""
                    } else {
                        dxSociete.mUpdate()
                        dxSociete.element().slideDown(200)
                    }
                    mConstruit()
                    if (option.onValueChanged) option.onValueChanged()
                },
                onContentReady: function (e) {
                    e.element.find(".dx-radiobutton").css({ "margin-top": "5px", "margin-bottom": "5px" })
                    e.element.find(".dx-item-content").css({ "font-family": "barlow condensed" })
                }
            }).dxRadioGroup("instance")
            //var dxChkSociete = $("<div style='margin:0px 10px 0 10px;'/>").appendTo(container).dxCheckBox({
            //    text: "Pour une société",
            //    value: (option.dataSaisie.is_societe == "1"),
            //    onValueChanged: function (e) {
            //        option.dataSaisie.is_societe = (e.value ? "1" : "0")
            //        if (option.dataSaisie.is_societe == "1") {
            //            dxSociete.element().slideDown(200)
            //        } else {
            //            dxSociete.element().slideUp(200)
            //            option.dataSaisie.nom_str = ""
            //            option.dataSaisie.siret = ""
            //            option.dataSaisie.tvaintra = ""
            //        }
            //        mConstruit()
            //        if (option.onValueChanged) option.onValueChanged()
            //    }
            //}).dxCheckBox("instance")

            dxSociete = $("<div style='padding:0 20px 10px 20px;border-left:" + theme.border + ";border-right:" + theme.border + ";border-bottom:" + theme.border + ";'/>").appendTo(container).dxCtrlSaisieSociete({
                bddCtrl: option.bddCtrl,
                value: option.dataSaisie,
                isExterne: option.isExterne,
                onFocusIn: onFocusInMobile,
                lstObligatoire: lstObligatoire,
                onSelectDataInsee: function (e) {
                    dxSaisieAdresse.mRempliWithInsee(e.value)
                },
                onValueChanged: function (e) {
                    if (option.onValueChanged) option.onValueChanged()
                }
            }).dxCtrlSaisieSociete("instance")
            if (option.dataSaisie.id_type_client == "0") dxSociete.element().css("display", "none")
        }


        dxSaisieAdresse = $("<div style='margin-top:10px;'/>").appendTo(container).dxCtrlSaisieAdresseDetail({
            bddCtrl: option.bddCtrl,
            value: option.dataSaisie,
            isExterne: option.isExterne,
            onFocusIn: onFocusInMobile,
            lstObligatoire: lstObligatoire,
            onValueChanged: function (e) {
                if (option.onValueChanged) option.onValueChanged()
            }
        }).dxCtrlSaisieAdresseDetail("instance")

        var containerTel = container
        if (option.showEmail) {
            var $Table = $("<table style='width:100%'/>").appendTo(container)
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='width:50%;'/>").appendTo($Tr)
            dxAdrEmail = $("<div/>").appendTo($Td).dxCtrlTextEmail({
                label: "Adresse email" + (lstObligatoire.contains("email") ? " *" : ""),
                labelMode: "floating",
                value: (option.dataSaisie ? (option.dataSaisie.adresse_email ? option.dataSaisie.adresse_email : "") : ""),
                onFocusIn: onFocusInMobile,
                onValueChanged: function (e) {
                    if (!dxAdrEmail.hasErreur && ((e.value == null) ? "" : e.value).length > 0) {
                        option.dataSaisie.adresse_email = e.value
                    } else {
                        option.dataSaisie.adresse_email = ""
                    }
                    if (option.onValueChanged) option.onValueChanged()
                },
                onContentReady: function (e) {
                    e.component.element().find(".dx-label").html("Adresse email" + (lstObligatoire.contains("email") ? " <b style='color:red;font-size:160%;'>*</b>" : ""))
                    if (option.isExterne) e.component.element().find("input").removeAttr('autocomplete');
                }
            }).dxCtrlTextEmail("instance")
            if (option.showTel) {
                containerTel = $("<td style='width:50%;'/>").appendTo($Tr)
            } else {
                $Td.css("width", "100%")
            }
        }
        if (option.showTel) {
            dxTel = $("<div style='margin:3px;'/>").appendTo(containerTel).dxCtrlTelephone({
                labelMode: "floating",
                label: "Téléphone" + (lstObligatoire.contains("tel") ? " *" : ""),
                bddCtrl: option.bddCtrl,
                width: "100%",
                typeTel: "mob",
                disableVerifSaisie: true,
                value: option.dataSaisie,
                onFocusIn: onFocusInMobile,
                onValueChanged: function (e) {
                    dxTel.element().css("background-color", "")
                    dxTel.element().css("border-left", "")
                    option.dataSaisie.tel_code_pays = e.value.tel_code_pays;
                    option.dataSaisie.tel_number = e.value.tel_number
                    option.dataSaisie.tel_complet = e.value.tel_complet
                    option.dataSaisie.tel_sms = e.value.tel_sms
                    option.dataSaisie.tel_error = e.value.tel_error
                    option.dataSaisie.tel_num_type = e.value.tel_num_type
                    if (option.onValueChanged) option.onValueChanged()
                },
                onContentReady: function (e) {
                    e.component.element().find(".dx-label").html("Téléphone" + (lstObligatoire.contains("tel") ? " <b style='color:red;font-size:160%;'>*</b>" : ""))
                    if (option.isExterne) e.component.element().find("input").removeAttr('autocomplete');
                }
            }).dxCtrlTelephone("instance")
        }


        container.css("height", "")
    }

    this.mColorObligatoire = function () {
        var lstCtrlOblig = []
        var lstChampOblige = option.onDemandeLstObligatoire(option.dataSaisie.id_type_client)
        if (lstChampOblige.contains("nom") && (!dxNom.option("value") || dxNom.option("value").length == 0)) {
            dxNom.element().css("background-color", "rgba(255, 0, 0,0.1)")
            lstCtrlOblig.push(dxNom)
        }
        if (lstChampOblige.contains("prenom") && (!dxPrenom.option("value") || dxPrenom.option("value").length == 0)) {
            dxPrenom.element().css("background-color", "rgba(255, 0, 0,0.1)")
            lstCtrlOblig.push(dxPrenom)
        }
        //lstCtrlOblig = lstCtrlOblig.concat(dxSaisieAdresse.mColorObligatoire())
        if (lstChampOblige.contains("tel") && dxTel && !dxTel.hasValue()) {
            dxTel.element().css("background-color", "rgba(255, 0, 0,0.1)")
            lstCtrlOblig.push(dxTel)
        }
        if (lstChampOblige.contains("email") && dxAdrEmail && !dxAdrEmail.hasValue()) {
            dxAdrEmail.element().css("background-color", "rgba(255, 0, 0,0.1)")
            lstCtrlOblig.push(dxAdrEmail)
        }
        if (dxSociete) {
            lstCtrlOblig = lstCtrlOblig.concat(dxSociete.mColorObligatoire(lstChampOblige))
        }
        if (dxSaisieAdresse) {
            lstCtrlOblig = lstCtrlOblig.concat(dxSaisieAdresse.mColorObligatoire(lstChampOblige))
        }
        return lstCtrlOblig
    }

    this.mReload = function () { mConstruit() }

    this.element = function () { return container }

    mConstruit();
}


